"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeInput = void 0;
const debounce_1 = __importDefault(require("lodash/debounce"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const react_1 = __importStar(require("react"));
const react_compound_slider_1 = require("react-compound-slider");
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_text_1 = require("@hotelplan/components.common.text");
const components_common_tooltip_1 = require("@hotelplan/components.common.tooltip");
const Handle_1 = require("./Handle");
const RangeInput_utils_1 = require("./RangeInput.utils");
const TooltipRail_1 = require("./TooltipRail");
const Track_1 = require("./Track");
const sliderStyle = {
    position: 'relative',
};
const RangeInputWrapper = styled_components_1.default.div(({ theme }) => theme.doubleRange.rangeInputWrapper);
const SliderWrapper = styled_components_1.default.div(({ theme }) => theme.doubleRange.sliderWrapper);
const RangeInput = (props) => {
    const { values, options, onChange, testId, loading, disabled: forceDisabled, showLeftTrack = true, getSingleRangeInputTooltip = RangeInput_utils_1.getSingleRangeInputTooltipCommon, getMultipleRangeInputTooltip = RangeInput_utils_1.getMultipleRangeInputTooltipCommon, customConfig, } = props;
    const disabled = forceDisabled || loading;
    const normalizedValues = (0, react_1.useMemo)(() => {
        return (0, RangeInput_utils_1.normalizeValues)(options, values);
    }, [options, values]);
    const onSlideEndHandler = (0, debounce_1.default)((nextNormalizedValues) => {
        const newValues = (0, RangeInput_utils_1.denormalizeValues)(options, nextNormalizedValues);
        if (newValues.length && !(0, isEqual_1.default)(values, newValues)) {
            onChange(newValues);
        }
    }, 100);
    const { onUpdate, step, movingTooltip, sliderValues, sliderDomain } = customConfig || {};
    return (react_1.default.createElement(RangeInputWrapper, { "data-id": testId },
        loading ? (react_1.default.createElement(components_common_text_1.TextLineSkeleton, { width: 100 })) : (react_1.default.createElement(react_1.default.Fragment, null, !movingTooltip ? (react_1.default.createElement("p", { className: "range-input-text", "data-id": "text" },
            values.length > 1 &&
                getMultipleRangeInputTooltip(options, values),
            values.length === 1 &&
                getSingleRangeInputTooltip(options, values))) : null)),
        react_1.default.createElement(SliderWrapper, null,
            react_1.default.createElement(react_compound_slider_1.Slider, { mode: 1, step: step || 1, domain: sliderDomain || [0, 100], rootStyle: sliderStyle, onSlideEnd: onSlideEndHandler, onUpdate: nextValues => onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(options, nextValues), values: sliderValues || normalizedValues, disabled: disabled },
                react_1.default.createElement(react_compound_slider_1.Rail, null, (railProps) => react_1.default.createElement(TooltipRail_1.TooltipRail, Object.assign({}, railProps))),
                react_1.default.createElement(react_compound_slider_1.Handles, null, ({ handles, activeHandleID, getHandleProps }) => (react_1.default.createElement("div", { className: "slider-handles" }, handles.map(handle => (react_1.default.createElement(Handle_1.Handle, { disabled: disabled, key: handle.id, handle: handle, domain: [0, 100], isActive: handle.id === activeHandleID, handleEvents: getHandleProps(handle.id), movingTooltip: movingTooltip ? (react_1.default.createElement(components_common_tooltip_1.Tooltip, { className: 'movingTooltip', withAutoPositioning: true }, getSingleRangeInputTooltip(options, values))) : null })))))),
                react_1.default.createElement(react_compound_slider_1.Tracks, { left: showLeftTrack, right: false }, ({ tracks, getTrackProps }) => (react_1.default.createElement("div", { className: "slider-tracks" }, tracks.map(({ id, source, target }) => (react_1.default.createElement(Track_1.Track, { disabled: disabled, key: id, source: source, target: target, getTrackProps: getTrackProps }))))))))));
};
exports.RangeInput = RangeInput;
//# sourceMappingURL=RangeInput.js.map